//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IEnterpriseGatewayApiProxy {
    actor_Get(service: AthumiService, voOrgCode: string | null | undefined, subjectId: string | null | undefined): Promise<ActorDto>;
    actor_Search(request: SearchActorsRequest): Promise<ActorSearchResultsDto>;
    actor_SubmitActor(request: SubmitActor): Promise<ActorDto>;
    announcement_GetActive(): Promise<ActiveAnnouncementDto[]>;
    announcement_GetAll(): Promise<AnnouncementDto[]>;
    announcement_Delete(announcementId: string): Promise<void>;
    announcement_Update(announcementId: string, announcementDto: AnnouncementDto): Promise<AnnouncementDto>;
    announcement_Create(announcementDto: AnnouncementDto): Promise<AnnouncementDto>;
    auth_Login(redirectUri: string | null | undefined, provider: string | null): Promise<FileResponse>;
    auth_LogOut(): Promise<FileResponse>;
    auth_SignOutComplete(): Promise<FileResponse>;
    auth_IsAuthenticated(): Promise<boolean>;
    auth_GetUserData(): Promise<UserData>;
    invoice_CreatePostPaidSession(request: CreatePostPaidSession): Promise<PostPaidSession>;
    invoice_CreatePostPaidSessionFedNot(request: CreatePostPaidSession): Promise<PostPaidSession>;
    invoice_CreateSelfBillingSession(request: CreateSelfBillingSession): Promise<SelfBillingSession>;
    invoice_Search(request: InvoicesQuery): Promise<InvoicesDto>;
    invoice_DownloadInvoice(documentType: DocumentType, invoiceNumber: string, fileType: InvoiceFileType): Promise<Stream>;
    invoice_DownloadInvoiceForActor(actorId: string, documentType: DocumentType, invoiceNumber: string, fileType: InvoiceFileType): Promise<Stream>;
    invoice_DownloadPurchaseInvoice(invoiceNumber: string, fileType: InvoiceFileType): Promise<Stream>;
    invoice_DownloadInvoices(actorId: string | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, docNr: string | null | undefined, customerReference: string | null | undefined): Promise<Stream>;
    invoiceRound_GetAll(offset: number | null | undefined, limit: number | null | undefined): Promise<InvoiceRoundDto[]>;
    invoiceSettings_GetByActorId(athumiService: AthumiService, actorId: string): Promise<InvoiceSettings[]>;
    invoiceSettings_Update(invoiceSettingsId: string, request: UpdateInvoiceSettingsRequest): Promise<InvoiceSettings>;
    location_GetAddressSuggestion(address: string): Promise<string[]>;
    location_GetZipCodes(city: string, street: string): Promise<string[]>;
    location_GetStreetNumbers(city: string, street: string): Promise<string[]>;
    mockPayment_Payment(sessionId: string, sessionType: SessionType): Promise<PaymentProviderInfo>;
    mockPayment_Pay(sessionId: string, sessionType: SessionType): Promise<string>;
    mockPayment_Decline(sessionId: string, sessionType: SessionType): Promise<string>;
    operations_SessionsSearch(query: SearchSessionsQuery): Promise<SessionsDto>;
    operations_GetSession(sessionId: string, sessionType: SessionType): Promise<SessionDetailDto>;
    operations_MessageQueueCount(): Promise<MessageQueueCountDto[]>;
    operations_Dashboard(): Promise<DashboardDto>;
    operations_Anomalies(): Promise<AnomaliesDetailDto>;
    operations_HealthChecks(): Promise<HealthCheckDto[]>;
    operations_DeadLetterQueueDetails(queueName: string): Promise<DeadLetterMessage[]>;
    operations_DeleteDeadLetters(queueName: string, messageIds: string[]): Promise<string[]>;
    operations_RequeueDeadLetters(queueName: string, messageIds: string[]): Promise<string[]>;
    operations_GetActorByKbo(kboNumber: string): Promise<OperationsActorDto>;
    operations_GetActorByOrgCode(orgCode: string): Promise<OperationsActorDto>;
    operations_GetActorByOvoCode(ovoCode: string): Promise<OperationsActorDto>;
    operations_GetActorBySubjectId(subjectId: string): Promise<OperationsActorDto>;
    operations_GetActorById(actorId: string): Promise<OperationsActorDto>;
    operations_GetActorCustomerNumber(actorId: string): Promise<string>;
    operations_UpdateActorEmailsByActorId(actorId: string, service: AthumiService, emails: string[]): Promise<boolean>;
    operations_UpdateActorByActorId(actorId: string, info: OperationsActorInfo): Promise<boolean>;
    operations_GetActorAuditLogsByActorId(actorId: string): Promise<ActorAuditLogDto[]>;
    operations_InvoicesSearch(request: AllInvoicesQuery): Promise<InvoicesDto>;
    operations_DownloadInvoices(actorId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, docNr: string | null | undefined, customerReference: string | null | undefined, documentType: DocumentType | null | undefined, service: AthumiService | null | undefined): Promise<Stream>;
    operations_PaymentRequestInvoicesSearch(request: PaymentRequestInvoicesQuery): Promise<InvoicesDto>;
    operations_DownloadPaymentRequestInvoices(fromDate: string | null | undefined, toDate: string | null | undefined, docNr: string | null | undefined, service: AthumiService | null | undefined): Promise<Stream>;
    operations_PurchaseInvoicesSearch(request: AllPurchaseInvoicesQuery): Promise<PurchaseInvoicesDto>;
    operations_DownloadPurchaseInvoices(fromDate: string | null | undefined, toDate: string | null | undefined, docNr: string | null | undefined, service: AthumiService | null | undefined): Promise<Stream>;
    payment_Create(request: CreatePaymentSession): Promise<PaymentSession>;
    payment_Get(sessionId: string): Promise<PaymentSession>;
    payment_Submit(sessionId: string, request: SubmitPaymentSession): Promise<PaymentSession>;
    payment_Cancel(sessionId: string): Promise<PaymentSession>;
    processing_Get(sessionId: string | undefined): Promise<ProcessingSession>;
    processing_CheckPaymentProviderStatus(sessionId: string | undefined, hostedCheckoutId: string | null | undefined, returnMac: string | null | undefined): Promise<ProcessingSession>;
    products_GetAll(): Promise<ProductPrice[]>;
    products_GetByService(athumiService: AthumiService): Promise<ProductPrice[]>;
    topUp_CreateAndSubmit(request: InstantSubmitTopUpSession): Promise<TopUpSession>;
}

export class EnterpriseGatewayApiProxy implements IEnterpriseGatewayApiProxy {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44331";

    }

    actor_Get(service: AthumiService, voOrgCode: string | null | undefined, subjectId: string | null | undefined, signal?: AbortSignal): Promise<ActorDto> {
        let url_ = this.baseUrl + "/bff/Actor/{service}?";
        if (service === undefined || service === null)
            throw new Error("The parameter 'service' must be defined.");
        url_ = url_.replace("{service}", encodeURIComponent("" + service));
        if (voOrgCode !== undefined && voOrgCode !== null)
            url_ += "voOrgCode=" + encodeURIComponent("" + voOrgCode) + "&";
        if (subjectId !== undefined && subjectId !== null)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActor_Get(_response);
        });
    }

    protected processActor_Get(response: AxiosResponse): Promise<ActorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActorDto.fromJS(resultData200);
            return Promise.resolve<ActorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActorDto>(null as any);
    }

    actor_Search(request: SearchActorsRequest, signal?: AbortSignal): Promise<ActorSearchResultsDto> {
        let url_ = this.baseUrl + "/bff/Actor/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActor_Search(_response);
        });
    }

    protected processActor_Search(response: AxiosResponse): Promise<ActorSearchResultsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActorSearchResultsDto.fromJS(resultData200);
            return Promise.resolve<ActorSearchResultsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActorSearchResultsDto>(null as any);
    }

    actor_SubmitActor(request: SubmitActor, signal?: AbortSignal): Promise<ActorDto> {
        let url_ = this.baseUrl + "/bff/Actor/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActor_SubmitActor(_response);
        });
    }

    protected processActor_SubmitActor(response: AxiosResponse): Promise<ActorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActorDto.fromJS(resultData200);
            return Promise.resolve<ActorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActorDto>(null as any);
    }

    announcement_GetActive(signal?: AbortSignal): Promise<ActiveAnnouncementDto[]> {
        let url_ = this.baseUrl + "/bff/Announcement/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnnouncement_GetActive(_response);
        });
    }

    protected processAnnouncement_GetActive(response: AxiosResponse): Promise<ActiveAnnouncementDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveAnnouncementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActiveAnnouncementDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveAnnouncementDto[]>(null as any);
    }

    announcement_GetAll(signal?: AbortSignal): Promise<AnnouncementDto[]> {
        let url_ = this.baseUrl + "/bff/Announcement/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnnouncement_GetAll(_response);
        });
    }

    protected processAnnouncement_GetAll(response: AxiosResponse): Promise<AnnouncementDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnnouncementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AnnouncementDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnouncementDto[]>(null as any);
    }

    announcement_Delete(announcementId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Announcement/{announcementId}";
        if (announcementId === undefined || announcementId === null)
            throw new Error("The parameter 'announcementId' must be defined.");
        url_ = url_.replace("{announcementId}", encodeURIComponent("" + announcementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnnouncement_Delete(_response);
        });
    }

    protected processAnnouncement_Delete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    announcement_Update(announcementId: string, announcementDto: AnnouncementDto, signal?: AbortSignal): Promise<AnnouncementDto> {
        let url_ = this.baseUrl + "/bff/Announcement/{announcementId}";
        if (announcementId === undefined || announcementId === null)
            throw new Error("The parameter 'announcementId' must be defined.");
        url_ = url_.replace("{announcementId}", encodeURIComponent("" + announcementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(announcementDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnnouncement_Update(_response);
        });
    }

    protected processAnnouncement_Update(response: AxiosResponse): Promise<AnnouncementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnnouncementDto.fromJS(resultData200);
            return Promise.resolve<AnnouncementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnouncementDto>(null as any);
    }

    announcement_Create(announcementDto: AnnouncementDto, signal?: AbortSignal): Promise<AnnouncementDto> {
        let url_ = this.baseUrl + "/bff/Announcement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(announcementDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnnouncement_Create(_response);
        });
    }

    protected processAnnouncement_Create(response: AxiosResponse): Promise<AnnouncementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnnouncementDto.fromJS(resultData200);
            return Promise.resolve<AnnouncementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnouncementDto>(null as any);
    }

    auth_Login(redirectUri: string | null | undefined, provider: string | null, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/auth/login/{provider}?";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        if (redirectUri !== undefined && redirectUri !== null)
            url_ += "redirectUri=" + encodeURIComponent("" + redirectUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_Login(_response);
        });
    }

    protected processAuth_Login(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    auth_LogOut(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/auth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_LogOut(_response);
        });
    }

    protected processAuth_LogOut(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    auth_SignOutComplete(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/auth/logout/callback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_SignOutComplete(_response);
        });
    }

    protected processAuth_SignOutComplete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    auth_IsAuthenticated(signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/auth/isAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_IsAuthenticated(_response);
        });
    }

    protected processAuth_IsAuthenticated(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    auth_GetUserData(signal?: AbortSignal): Promise<UserData> {
        let url_ = this.baseUrl + "/auth/userData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_GetUserData(_response);
        });
    }

    protected processAuth_GetUserData(response: AxiosResponse): Promise<UserData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserData.fromJS(resultData200);
            return Promise.resolve<UserData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserData>(null as any);
    }

    invoice_CreatePostPaidSession(request: CreatePostPaidSession, signal?: AbortSignal): Promise<PostPaidSession> {
        let url_ = this.baseUrl + "/bff/Invoice/postpaid/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_CreatePostPaidSession(_response);
        });
    }

    protected processInvoice_CreatePostPaidSession(response: AxiosResponse): Promise<PostPaidSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostPaidSession.fromJS(resultData200);
            return Promise.resolve<PostPaidSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostPaidSession>(null as any);
    }

    invoice_CreatePostPaidSessionFedNot(request: CreatePostPaidSession, signal?: AbortSignal): Promise<PostPaidSession> {
        let url_ = this.baseUrl + "/bff/Invoice/postpaid/create/fednot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_CreatePostPaidSessionFedNot(_response);
        });
    }

    protected processInvoice_CreatePostPaidSessionFedNot(response: AxiosResponse): Promise<PostPaidSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostPaidSession.fromJS(resultData200);
            return Promise.resolve<PostPaidSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostPaidSession>(null as any);
    }

    invoice_CreateSelfBillingSession(request: CreateSelfBillingSession, signal?: AbortSignal): Promise<SelfBillingSession> {
        let url_ = this.baseUrl + "/bff/Invoice/selfbilling/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_CreateSelfBillingSession(_response);
        });
    }

    protected processInvoice_CreateSelfBillingSession(response: AxiosResponse): Promise<SelfBillingSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfBillingSession.fromJS(resultData200);
            return Promise.resolve<SelfBillingSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfBillingSession>(null as any);
    }

    invoice_Search(request: InvoicesQuery, signal?: AbortSignal): Promise<InvoicesDto> {
        let url_ = this.baseUrl + "/bff/Invoice/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_Search(_response);
        });
    }

    protected processInvoice_Search(response: AxiosResponse): Promise<InvoicesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoicesDto.fromJS(resultData200);
            return Promise.resolve<InvoicesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoicesDto>(null as any);
    }

    invoice_DownloadInvoice(documentType: DocumentType, invoiceNumber: string, fileType: InvoiceFileType, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Invoice/download/{documentType}/{invoiceNumber}/{fileType}";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined.");
        url_ = url_.replace("{documentType}", encodeURIComponent("" + documentType));
        if (invoiceNumber === undefined || invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' must be defined.");
        url_ = url_.replace("{invoiceNumber}", encodeURIComponent("" + invoiceNumber));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_DownloadInvoice(_response);
        });
    }

    protected processInvoice_DownloadInvoice(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    invoice_DownloadInvoiceForActor(actorId: string, documentType: DocumentType, invoiceNumber: string, fileType: InvoiceFileType, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Invoice/download/{actorId}/{documentType}/{invoiceNumber}/{fileType}";
        if (actorId === undefined || actorId === null)
            throw new Error("The parameter 'actorId' must be defined.");
        url_ = url_.replace("{actorId}", encodeURIComponent("" + actorId));
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined.");
        url_ = url_.replace("{documentType}", encodeURIComponent("" + documentType));
        if (invoiceNumber === undefined || invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' must be defined.");
        url_ = url_.replace("{invoiceNumber}", encodeURIComponent("" + invoiceNumber));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_DownloadInvoiceForActor(_response);
        });
    }

    protected processInvoice_DownloadInvoiceForActor(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    invoice_DownloadPurchaseInvoice(invoiceNumber: string, fileType: InvoiceFileType, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Invoice/purchase/download/{invoiceNumber}/{fileType}";
        if (invoiceNumber === undefined || invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' must be defined.");
        url_ = url_.replace("{invoiceNumber}", encodeURIComponent("" + invoiceNumber));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_DownloadPurchaseInvoice(_response);
        });
    }

    protected processInvoice_DownloadPurchaseInvoice(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    invoice_DownloadInvoices(actorId: string | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, docNr: string | null | undefined, customerReference: string | null | undefined, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Invoice/downloadInvoices?";
        if (actorId === null)
            throw new Error("The parameter 'actorId' cannot be null.");
        else if (actorId !== undefined)
            url_ += "actorId=" + encodeURIComponent("" + actorId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (docNr !== undefined && docNr !== null)
            url_ += "docNr=" + encodeURIComponent("" + docNr) + "&";
        if (customerReference !== undefined && customerReference !== null)
            url_ += "customerReference=" + encodeURIComponent("" + customerReference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_DownloadInvoices(_response);
        });
    }

    protected processInvoice_DownloadInvoices(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    invoiceRound_GetAll(offset: number | null | undefined, limit: number | null | undefined, signal?: AbortSignal): Promise<InvoiceRoundDto[]> {
        let url_ = this.baseUrl + "/bff/InvoiceRound?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoiceRound_GetAll(_response);
        });
    }

    protected processInvoiceRound_GetAll(response: AxiosResponse): Promise<InvoiceRoundDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceRoundDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceRoundDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceRoundDto[]>(null as any);
    }

    invoiceSettings_GetByActorId(athumiService: AthumiService, actorId: string, signal?: AbortSignal): Promise<InvoiceSettings[]> {
        let url_ = this.baseUrl + "/bff/InvoiceSettings/{athumiService}/{actorId}";
        if (athumiService === undefined || athumiService === null)
            throw new Error("The parameter 'athumiService' must be defined.");
        url_ = url_.replace("{athumiService}", encodeURIComponent("" + athumiService));
        if (actorId === undefined || actorId === null)
            throw new Error("The parameter 'actorId' must be defined.");
        url_ = url_.replace("{actorId}", encodeURIComponent("" + actorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoiceSettings_GetByActorId(_response);
        });
    }

    protected processInvoiceSettings_GetByActorId(response: AxiosResponse): Promise<InvoiceSettings[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceSettings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceSettings[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceSettings[]>(null as any);
    }

    invoiceSettings_Update(invoiceSettingsId: string, request: UpdateInvoiceSettingsRequest, signal?: AbortSignal): Promise<InvoiceSettings> {
        let url_ = this.baseUrl + "/bff/InvoiceSettings/{invoiceSettingsId}";
        if (invoiceSettingsId === undefined || invoiceSettingsId === null)
            throw new Error("The parameter 'invoiceSettingsId' must be defined.");
        url_ = url_.replace("{invoiceSettingsId}", encodeURIComponent("" + invoiceSettingsId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoiceSettings_Update(_response);
        });
    }

    protected processInvoiceSettings_Update(response: AxiosResponse): Promise<InvoiceSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceSettings.fromJS(resultData200);
            return Promise.resolve<InvoiceSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceSettings>(null as any);
    }

    location_GetAddressSuggestion(address: string, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/bff/Location/AddressSuggestion/{address}";
        if (address === undefined || address === null)
            throw new Error("The parameter 'address' must be defined.");
        url_ = url_.replace("{address}", encodeURIComponent("" + address));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocation_GetAddressSuggestion(_response);
        });
    }

    protected processLocation_GetAddressSuggestion(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    location_GetZipCodes(city: string, street: string, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/bff/Location/ZipCodes/{city}/{street}";
        if (city === undefined || city === null)
            throw new Error("The parameter 'city' must be defined.");
        url_ = url_.replace("{city}", encodeURIComponent("" + city));
        if (street === undefined || street === null)
            throw new Error("The parameter 'street' must be defined.");
        url_ = url_.replace("{street}", encodeURIComponent("" + street));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocation_GetZipCodes(_response);
        });
    }

    protected processLocation_GetZipCodes(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    location_GetStreetNumbers(city: string, street: string, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/bff/Location/StreetNumbers/{city}/{street}";
        if (city === undefined || city === null)
            throw new Error("The parameter 'city' must be defined.");
        url_ = url_.replace("{city}", encodeURIComponent("" + city));
        if (street === undefined || street === null)
            throw new Error("The parameter 'street' must be defined.");
        url_ = url_.replace("{street}", encodeURIComponent("" + street));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocation_GetStreetNumbers(_response);
        });
    }

    protected processLocation_GetStreetNumbers(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    mockPayment_Payment(sessionId: string, sessionType: SessionType, signal?: AbortSignal): Promise<PaymentProviderInfo> {
        let url_ = this.baseUrl + "/bff/payment/mock/{sessionId}/{sessionType}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (sessionType === undefined || sessionType === null)
            throw new Error("The parameter 'sessionType' must be defined.");
        url_ = url_.replace("{sessionType}", encodeURIComponent("" + sessionType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMockPayment_Payment(_response);
        });
    }

    protected processMockPayment_Payment(response: AxiosResponse): Promise<PaymentProviderInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentProviderInfo.fromJS(resultData200);
            return Promise.resolve<PaymentProviderInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentProviderInfo>(null as any);
    }

    mockPayment_Pay(sessionId: string, sessionType: SessionType, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/bff/payment/mock/Pay/{sessionId}/{sessionType}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (sessionType === undefined || sessionType === null)
            throw new Error("The parameter 'sessionType' must be defined.");
        url_ = url_.replace("{sessionType}", encodeURIComponent("" + sessionType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMockPayment_Pay(_response);
        });
    }

    protected processMockPayment_Pay(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    mockPayment_Decline(sessionId: string, sessionType: SessionType, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/bff/payment/mock/Decline/{sessionId}/{sessionType}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (sessionType === undefined || sessionType === null)
            throw new Error("The parameter 'sessionType' must be defined.");
        url_ = url_.replace("{sessionType}", encodeURIComponent("" + sessionType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMockPayment_Decline(_response);
        });
    }

    protected processMockPayment_Decline(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    operations_SessionsSearch(query: SearchSessionsQuery, signal?: AbortSignal): Promise<SessionsDto> {
        let url_ = this.baseUrl + "/bff/Operations/sessions/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_SessionsSearch(_response);
        });
    }

    protected processOperations_SessionsSearch(response: AxiosResponse): Promise<SessionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SessionsDto.fromJS(resultData200);
            return Promise.resolve<SessionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionsDto>(null as any);
    }

    operations_GetSession(sessionId: string, sessionType: SessionType, signal?: AbortSignal): Promise<SessionDetailDto> {
        let url_ = this.baseUrl + "/bff/Operations/sessions/{sessionId}/{sessionType}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (sessionType === undefined || sessionType === null)
            throw new Error("The parameter 'sessionType' must be defined.");
        url_ = url_.replace("{sessionType}", encodeURIComponent("" + sessionType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetSession(_response);
        });
    }

    protected processOperations_GetSession(response: AxiosResponse): Promise<SessionDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SessionDetailDto.fromJS(resultData200);
            return Promise.resolve<SessionDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionDetailDto>(null as any);
    }

    operations_MessageQueueCount(signal?: AbortSignal): Promise<MessageQueueCountDto[]> {
        let url_ = this.baseUrl + "/bff/Operations/messagequeue/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_MessageQueueCount(_response);
        });
    }

    protected processOperations_MessageQueueCount(response: AxiosResponse): Promise<MessageQueueCountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageQueueCountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MessageQueueCountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageQueueCountDto[]>(null as any);
    }

    operations_Dashboard(signal?: AbortSignal): Promise<DashboardDto> {
        let url_ = this.baseUrl + "/bff/Operations/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_Dashboard(_response);
        });
    }

    protected processOperations_Dashboard(response: AxiosResponse): Promise<DashboardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DashboardDto.fromJS(resultData200);
            return Promise.resolve<DashboardDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardDto>(null as any);
    }

    operations_Anomalies(signal?: AbortSignal): Promise<AnomaliesDetailDto> {
        let url_ = this.baseUrl + "/bff/Operations/dashboard/anomalies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_Anomalies(_response);
        });
    }

    protected processOperations_Anomalies(response: AxiosResponse): Promise<AnomaliesDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnomaliesDetailDto.fromJS(resultData200);
            return Promise.resolve<AnomaliesDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnomaliesDetailDto>(null as any);
    }

    operations_HealthChecks(signal?: AbortSignal): Promise<HealthCheckDto[]> {
        let url_ = this.baseUrl + "/bff/Operations/healthchecks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_HealthChecks(_response);
        });
    }

    protected processOperations_HealthChecks(response: AxiosResponse): Promise<HealthCheckDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HealthCheckDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HealthCheckDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HealthCheckDto[]>(null as any);
    }

    operations_DeadLetterQueueDetails(queueName: string, signal?: AbortSignal): Promise<DeadLetterMessage[]> {
        let url_ = this.baseUrl + "/bff/Operations/messagequeue/deadletters/{queueName}";
        if (queueName === undefined || queueName === null)
            throw new Error("The parameter 'queueName' must be defined.");
        url_ = url_.replace("{queueName}", encodeURIComponent("" + queueName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_DeadLetterQueueDetails(_response);
        });
    }

    protected processOperations_DeadLetterQueueDetails(response: AxiosResponse): Promise<DeadLetterMessage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeadLetterMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeadLetterMessage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeadLetterMessage[]>(null as any);
    }

    operations_DeleteDeadLetters(queueName: string, messageIds: string[], signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/bff/Operations/messagequeue/deadletters/{queueName}";
        if (queueName === undefined || queueName === null)
            throw new Error("The parameter 'queueName' must be defined.");
        url_ = url_.replace("{queueName}", encodeURIComponent("" + queueName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_DeleteDeadLetters(_response);
        });
    }

    protected processOperations_DeleteDeadLetters(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    operations_RequeueDeadLetters(queueName: string, messageIds: string[], signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/bff/Operations/messagequeue/deadletters/requeue/{queueName}";
        if (queueName === undefined || queueName === null)
            throw new Error("The parameter 'queueName' must be defined.");
        url_ = url_.replace("{queueName}", encodeURIComponent("" + queueName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_RequeueDeadLetters(_response);
        });
    }

    protected processOperations_RequeueDeadLetters(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    operations_GetActorByKbo(kboNumber: string, signal?: AbortSignal): Promise<OperationsActorDto> {
        let url_ = this.baseUrl + "/bff/Operations/actor/kbo/{kboNumber}";
        if (kboNumber === undefined || kboNumber === null)
            throw new Error("The parameter 'kboNumber' must be defined.");
        url_ = url_.replace("{kboNumber}", encodeURIComponent("" + kboNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetActorByKbo(_response);
        });
    }

    protected processOperations_GetActorByKbo(response: AxiosResponse): Promise<OperationsActorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperationsActorDto.fromJS(resultData200);
            return Promise.resolve<OperationsActorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationsActorDto>(null as any);
    }

    operations_GetActorByOrgCode(orgCode: string, signal?: AbortSignal): Promise<OperationsActorDto> {
        let url_ = this.baseUrl + "/bff/Operations/actor/orgCode/{orgCode}";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined.");
        url_ = url_.replace("{orgCode}", encodeURIComponent("" + orgCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetActorByOrgCode(_response);
        });
    }

    protected processOperations_GetActorByOrgCode(response: AxiosResponse): Promise<OperationsActorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperationsActorDto.fromJS(resultData200);
            return Promise.resolve<OperationsActorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationsActorDto>(null as any);
    }

    operations_GetActorByOvoCode(ovoCode: string, signal?: AbortSignal): Promise<OperationsActorDto> {
        let url_ = this.baseUrl + "/bff/Operations/actor/ovoCode/{ovoCode}";
        if (ovoCode === undefined || ovoCode === null)
            throw new Error("The parameter 'ovoCode' must be defined.");
        url_ = url_.replace("{ovoCode}", encodeURIComponent("" + ovoCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetActorByOvoCode(_response);
        });
    }

    protected processOperations_GetActorByOvoCode(response: AxiosResponse): Promise<OperationsActorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperationsActorDto.fromJS(resultData200);
            return Promise.resolve<OperationsActorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationsActorDto>(null as any);
    }

    operations_GetActorBySubjectId(subjectId: string, signal?: AbortSignal): Promise<OperationsActorDto> {
        let url_ = this.baseUrl + "/bff/Operations/actor/subjectId/{subjectId}";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetActorBySubjectId(_response);
        });
    }

    protected processOperations_GetActorBySubjectId(response: AxiosResponse): Promise<OperationsActorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperationsActorDto.fromJS(resultData200);
            return Promise.resolve<OperationsActorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationsActorDto>(null as any);
    }

    operations_GetActorById(actorId: string, signal?: AbortSignal): Promise<OperationsActorDto> {
        let url_ = this.baseUrl + "/bff/Operations/actor/id/{actorId}";
        if (actorId === undefined || actorId === null)
            throw new Error("The parameter 'actorId' must be defined.");
        url_ = url_.replace("{actorId}", encodeURIComponent("" + actorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetActorById(_response);
        });
    }

    protected processOperations_GetActorById(response: AxiosResponse): Promise<OperationsActorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperationsActorDto.fromJS(resultData200);
            return Promise.resolve<OperationsActorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationsActorDto>(null as any);
    }

    operations_GetActorCustomerNumber(actorId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/bff/Operations/actor/id/{actorId}/customernumber";
        if (actorId === undefined || actorId === null)
            throw new Error("The parameter 'actorId' must be defined.");
        url_ = url_.replace("{actorId}", encodeURIComponent("" + actorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetActorCustomerNumber(_response);
        });
    }

    protected processOperations_GetActorCustomerNumber(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    operations_UpdateActorEmailsByActorId(actorId: string, service: AthumiService, emails: string[], signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/bff/Operations/actor/{actorId}/services/{service}/emails";
        if (actorId === undefined || actorId === null)
            throw new Error("The parameter 'actorId' must be defined.");
        url_ = url_.replace("{actorId}", encodeURIComponent("" + actorId));
        if (service === undefined || service === null)
            throw new Error("The parameter 'service' must be defined.");
        url_ = url_.replace("{service}", encodeURIComponent("" + service));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emails);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_UpdateActorEmailsByActorId(_response);
        });
    }

    protected processOperations_UpdateActorEmailsByActorId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    operations_UpdateActorByActorId(actorId: string, info: OperationsActorInfo, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/bff/Operations/actor/{actorId}";
        if (actorId === undefined || actorId === null)
            throw new Error("The parameter 'actorId' must be defined.");
        url_ = url_.replace("{actorId}", encodeURIComponent("" + actorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(info);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_UpdateActorByActorId(_response);
        });
    }

    protected processOperations_UpdateActorByActorId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    operations_GetActorAuditLogsByActorId(actorId: string, signal?: AbortSignal): Promise<ActorAuditLogDto[]> {
        let url_ = this.baseUrl + "/bff/Operations/actor/{actorId}/auditlogs";
        if (actorId === undefined || actorId === null)
            throw new Error("The parameter 'actorId' must be defined.");
        url_ = url_.replace("{actorId}", encodeURIComponent("" + actorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetActorAuditLogsByActorId(_response);
        });
    }

    protected processOperations_GetActorAuditLogsByActorId(response: AxiosResponse): Promise<ActorAuditLogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActorAuditLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActorAuditLogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActorAuditLogDto[]>(null as any);
    }

    operations_InvoicesSearch(request: AllInvoicesQuery, signal?: AbortSignal): Promise<InvoicesDto> {
        let url_ = this.baseUrl + "/bff/Operations/invoices/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_InvoicesSearch(_response);
        });
    }

    protected processOperations_InvoicesSearch(response: AxiosResponse): Promise<InvoicesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoicesDto.fromJS(resultData200);
            return Promise.resolve<InvoicesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoicesDto>(null as any);
    }

    operations_DownloadInvoices(actorId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, docNr: string | null | undefined, customerReference: string | null | undefined, documentType: DocumentType | null | undefined, service: AthumiService | null | undefined, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Operations/downloadInvoices?";
        if (actorId !== undefined && actorId !== null)
            url_ += "actorId=" + encodeURIComponent("" + actorId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (docNr !== undefined && docNr !== null)
            url_ += "docNr=" + encodeURIComponent("" + docNr) + "&";
        if (customerReference !== undefined && customerReference !== null)
            url_ += "customerReference=" + encodeURIComponent("" + customerReference) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (service !== undefined && service !== null)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_DownloadInvoices(_response);
        });
    }

    protected processOperations_DownloadInvoices(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    operations_PaymentRequestInvoicesSearch(request: PaymentRequestInvoicesQuery, signal?: AbortSignal): Promise<InvoicesDto> {
        let url_ = this.baseUrl + "/bff/Operations/invoices/paymentrequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_PaymentRequestInvoicesSearch(_response);
        });
    }

    protected processOperations_PaymentRequestInvoicesSearch(response: AxiosResponse): Promise<InvoicesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoicesDto.fromJS(resultData200);
            return Promise.resolve<InvoicesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoicesDto>(null as any);
    }

    operations_DownloadPaymentRequestInvoices(fromDate: string | null | undefined, toDate: string | null | undefined, docNr: string | null | undefined, service: AthumiService | null | undefined, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Operations/downloadPaymentRequestInvoices?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (docNr !== undefined && docNr !== null)
            url_ += "docNr=" + encodeURIComponent("" + docNr) + "&";
        if (service !== undefined && service !== null)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_DownloadPaymentRequestInvoices(_response);
        });
    }

    protected processOperations_DownloadPaymentRequestInvoices(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    operations_PurchaseInvoicesSearch(request: AllPurchaseInvoicesQuery, signal?: AbortSignal): Promise<PurchaseInvoicesDto> {
        let url_ = this.baseUrl + "/bff/Operations/invoices/purchase/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_PurchaseInvoicesSearch(_response);
        });
    }

    protected processOperations_PurchaseInvoicesSearch(response: AxiosResponse): Promise<PurchaseInvoicesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchaseInvoicesDto.fromJS(resultData200);
            return Promise.resolve<PurchaseInvoicesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseInvoicesDto>(null as any);
    }

    operations_DownloadPurchaseInvoices(fromDate: string | null | undefined, toDate: string | null | undefined, docNr: string | null | undefined, service: AthumiService | null | undefined, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Operations/downloadPurchaseInvoices?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (docNr !== undefined && docNr !== null)
            url_ += "docNr=" + encodeURIComponent("" + docNr) + "&";
        if (service !== undefined && service !== null)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_DownloadPurchaseInvoices(_response);
        });
    }

    protected processOperations_DownloadPurchaseInvoices(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    payment_Create(request: CreatePaymentSession, signal?: AbortSignal): Promise<PaymentSession> {
        let url_ = this.baseUrl + "/bff/Payment/session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_Create(_response);
        });
    }

    protected processPayment_Create(response: AxiosResponse): Promise<PaymentSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentSession.fromJS(resultData200);
            return Promise.resolve<PaymentSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentSession>(null as any);
    }

    payment_Get(sessionId: string, signal?: AbortSignal): Promise<PaymentSession> {
        let url_ = this.baseUrl + "/bff/Payment/session/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_Get(_response);
        });
    }

    protected processPayment_Get(response: AxiosResponse): Promise<PaymentSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentSession.fromJS(resultData200);
            return Promise.resolve<PaymentSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentSession>(null as any);
    }

    payment_Submit(sessionId: string, request: SubmitPaymentSession, signal?: AbortSignal): Promise<PaymentSession> {
        let url_ = this.baseUrl + "/bff/Payment/session/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_Submit(_response);
        });
    }

    protected processPayment_Submit(response: AxiosResponse): Promise<PaymentSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentSession.fromJS(resultData200);
            return Promise.resolve<PaymentSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentSession>(null as any);
    }

    payment_Cancel(sessionId: string, signal?: AbortSignal): Promise<PaymentSession> {
        let url_ = this.baseUrl + "/bff/Payment/session/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_Cancel(_response);
        });
    }

    protected processPayment_Cancel(response: AxiosResponse): Promise<PaymentSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentSession.fromJS(resultData200);
            return Promise.resolve<PaymentSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentSession>(null as any);
    }

    processing_Get(sessionId: string | undefined, signal?: AbortSignal): Promise<ProcessingSession> {
        let url_ = this.baseUrl + "/bff/Processing/session?";
        if (sessionId === null)
            throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessing_Get(_response);
        });
    }

    protected processProcessing_Get(response: AxiosResponse): Promise<ProcessingSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessingSession.fromJS(resultData200);
            return Promise.resolve<ProcessingSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingSession>(null as any);
    }

    processing_CheckPaymentProviderStatus(sessionId: string | undefined, hostedCheckoutId: string | null | undefined, returnMac: string | null | undefined, signal?: AbortSignal): Promise<ProcessingSession> {
        let url_ = this.baseUrl + "/bff/Processing/session/CheckPaymentProviderStatus?";
        if (sessionId === null)
            throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (hostedCheckoutId !== undefined && hostedCheckoutId !== null)
            url_ += "hostedCheckoutId=" + encodeURIComponent("" + hostedCheckoutId) + "&";
        if (returnMac !== undefined && returnMac !== null)
            url_ += "returnMac=" + encodeURIComponent("" + returnMac) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessing_CheckPaymentProviderStatus(_response);
        });
    }

    protected processProcessing_CheckPaymentProviderStatus(response: AxiosResponse): Promise<ProcessingSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessingSession.fromJS(resultData200);
            return Promise.resolve<ProcessingSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingSession>(null as any);
    }

    products_GetAll(signal?: AbortSignal): Promise<ProductPrice[]> {
        let url_ = this.baseUrl + "/bff/Products";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetAll(_response);
        });
    }

    protected processProducts_GetAll(response: AxiosResponse): Promise<ProductPrice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductPrice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductPrice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductPrice[]>(null as any);
    }

    products_GetByService(athumiService: AthumiService, signal?: AbortSignal): Promise<ProductPrice[]> {
        let url_ = this.baseUrl + "/bff/Products/{athumiService}";
        if (athumiService === undefined || athumiService === null)
            throw new Error("The parameter 'athumiService' must be defined.");
        url_ = url_.replace("{athumiService}", encodeURIComponent("" + athumiService));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetByService(_response);
        });
    }

    protected processProducts_GetByService(response: AxiosResponse): Promise<ProductPrice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductPrice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductPrice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductPrice[]>(null as any);
    }

    topUp_CreateAndSubmit(request: InstantSubmitTopUpSession, signal?: AbortSignal): Promise<TopUpSession> {
        let url_ = this.baseUrl + "/bff/TopUp/session/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTopUp_CreateAndSubmit(_response);
        });
    }

    protected processTopUp_CreateAndSubmit(response: AxiosResponse): Promise<TopUpSession> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TopUpSession.fromJS(resultData200);
            return Promise.resolve<TopUpSession>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopUpSession>(null as any);
    }
}

export class ActorDto implements IActorDto {
    id?: string;
    identifier?: string | undefined;
    name?: string;
    firstname?: string;
    lastname?: string;
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    county?: string;
    countryCode?: string;
    vatNumber?: string;
    email?: string;
    walletUnavailable?: boolean;
    serviceBalance?: number | undefined;

    constructor(data?: IActorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.countryCode = _data["countryCode"];
            this.vatNumber = _data["vatNumber"];
            this.email = _data["email"];
            this.walletUnavailable = _data["walletUnavailable"];
            this.serviceBalance = _data["serviceBalance"];
        }
    }

    static fromJS(data: any): ActorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["county"] = this.county;
        data["countryCode"] = this.countryCode;
        data["vatNumber"] = this.vatNumber;
        data["email"] = this.email;
        data["walletUnavailable"] = this.walletUnavailable;
        data["serviceBalance"] = this.serviceBalance;
        return data;
    }
}

export interface IActorDto {
    id?: string;
    identifier?: string | undefined;
    name?: string;
    firstname?: string;
    lastname?: string;
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    county?: string;
    countryCode?: string;
    vatNumber?: string;
    email?: string;
    walletUnavailable?: boolean;
    serviceBalance?: number | undefined;
}

export enum AthumiService {
    All = "All",
    Klip = "Klip",
    Vip = "Vip",
    ELys = "ELys",
}

export class ActorSearchResultsDto implements IActorSearchResultsDto {
    actors?: ActorSearchResult[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;

    constructor(data?: IActorSearchResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actors"])) {
                this.actors = [] as any;
                for (let item of _data["actors"])
                    this.actors!.push(ActorSearchResult.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): ActorSearchResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActorSearchResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actors)) {
            data["actors"] = [];
            for (let item of this.actors)
                data["actors"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IActorSearchResultsDto {
    actors?: ActorSearchResult[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;
}

export class ActorSearchResult implements IActorSearchResult {
    id?: string;
    identifier?: string;
    name?: string;
    vatNumber?: string;
    serviceBalances?: ServiceBalance[];

    constructor(data?: IActorSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            if (Array.isArray(_data["serviceBalances"])) {
                this.serviceBalances = [] as any;
                for (let item of _data["serviceBalances"])
                    this.serviceBalances!.push(ServiceBalance.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActorSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new ActorSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        if (Array.isArray(this.serviceBalances)) {
            data["serviceBalances"] = [];
            for (let item of this.serviceBalances)
                data["serviceBalances"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActorSearchResult {
    id?: string;
    identifier?: string;
    name?: string;
    vatNumber?: string;
    serviceBalances?: ServiceBalance[];
}

export class ServiceBalance implements IServiceBalance {
    service?: AthumiService;
    balance?: number | undefined;

    constructor(data?: IServiceBalance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): ServiceBalance {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceBalance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["balance"] = this.balance;
        return data;
    }
}

export interface IServiceBalance {
    service?: AthumiService;
    balance?: number | undefined;
}

export class SearchActorsRequest implements ISearchActorsRequest {
    identifier?: string | undefined;
    name?: string | undefined;
    services?: AthumiService[];
    page?: number | undefined;
    pageSize?: number | undefined;

    constructor(data?: ISearchActorsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): SearchActorsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchActorsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface ISearchActorsRequest {
    identifier?: string | undefined;
    name?: string | undefined;
    services?: AthumiService[];
    page?: number | undefined;
    pageSize?: number | undefined;
}

export class SubmitActor implements ISubmitActor {
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    voOrgCode?: string | undefined;
    subjectId?: string | undefined;
    vatNumber?: string | undefined;
    street?: string;
    streetNumber?: string;
    bus?: string | undefined;
    postCode?: string;
    city?: string;
    countryRegionCode?: string;
    emails?: ServiceEmail[];

    constructor(data?: ISubmitActor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.voOrgCode = _data["voOrgCode"];
            this.subjectId = _data["subjectId"];
            this.vatNumber = _data["vatNumber"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryRegionCode = _data["countryRegionCode"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(ServiceEmail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitActor {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitActor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["voOrgCode"] = this.voOrgCode;
        data["subjectId"] = this.subjectId;
        data["vatNumber"] = this.vatNumber;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryRegionCode"] = this.countryRegionCode;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmitActor {
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    voOrgCode?: string | undefined;
    subjectId?: string | undefined;
    vatNumber?: string | undefined;
    street?: string;
    streetNumber?: string;
    bus?: string | undefined;
    postCode?: string;
    city?: string;
    countryRegionCode?: string;
    emails?: ServiceEmail[];
}

export class ServiceEmail implements IServiceEmail {
    service?: AthumiService;
    email?: string;

    constructor(data?: IServiceEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ServiceEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["email"] = this.email;
        return data;
    }
}

export interface IServiceEmail {
    service?: AthumiService;
    email?: string;
}

export class ActiveAnnouncementDto implements IActiveAnnouncementDto {
    title?: string;
    message?: string;
    severity?: AnnouncementSeverity;
    athumiService?: AthumiService;
    id?: string;

    constructor(data?: IActiveAnnouncementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.message = _data["message"];
            this.severity = _data["severity"];
            this.athumiService = _data["athumiService"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActiveAnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["message"] = this.message;
        data["severity"] = this.severity;
        data["athumiService"] = this.athumiService;
        data["id"] = this.id;
        return data;
    }
}

export interface IActiveAnnouncementDto {
    title?: string;
    message?: string;
    severity?: AnnouncementSeverity;
    athumiService?: AthumiService;
    id?: string;
}

export enum AnnouncementSeverity {
    New = "New",
    Info = "Info",
    Warning = "Warning",
    Critical = "Critical",
}

export class AnnouncementDto implements IAnnouncementDto {
    id?: string | undefined;
    severity?: AnnouncementSeverity;
    from?: string;
    to?: string | undefined;
    title?: string;
    message?: string;

    constructor(data?: IAnnouncementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.severity = _data["severity"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.title = _data["title"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["severity"] = this.severity;
        data["from"] = this.from;
        data["to"] = this.to;
        data["title"] = this.title;
        data["message"] = this.message;
        return data;
    }
}

export interface IAnnouncementDto {
    id?: string | undefined;
    severity?: AnnouncementSeverity;
    from?: string;
    to?: string | undefined;
    title?: string;
    message?: string;
}

export class UserData implements IUserData {
    id?: string | undefined;
    applicationName?: string | undefined;
    organisationName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    voOrgCode?: string | undefined;
    isForeign?: boolean;
    isCitizen?: boolean;
    isOvo?: boolean;
    isAdmin?: boolean;
    scopes?: string[] | undefined;
    services?: AthumiService[] | undefined;
    actorInfo?: ActorDto | undefined;
    actors?: { [key: string]: ActorDto; } | undefined;
    actorServiceDown?: boolean;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationName = _data["applicationName"];
            this.organisationName = _data["organisationName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.voOrgCode = _data["voOrgCode"];
            this.isForeign = _data["isForeign"];
            this.isCitizen = _data["isCitizen"];
            this.isOvo = _data["isOvo"];
            this.isAdmin = _data["isAdmin"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
            this.actorInfo = _data["actorInfo"] ? ActorDto.fromJS(_data["actorInfo"]) : <any>undefined;
            if (_data["actors"]) {
                this.actors = {} as any;
                for (let key in _data["actors"]) {
                    if (_data["actors"].hasOwnProperty(key))
                        (<any>this.actors)![key] = _data["actors"][key] ? ActorDto.fromJS(_data["actors"][key]) : new ActorDto();
                }
            }
            this.actorServiceDown = _data["actorServiceDown"];
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationName"] = this.applicationName;
        data["organisationName"] = this.organisationName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["voOrgCode"] = this.voOrgCode;
        data["isForeign"] = this.isForeign;
        data["isCitizen"] = this.isCitizen;
        data["isOvo"] = this.isOvo;
        data["isAdmin"] = this.isAdmin;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        data["actorInfo"] = this.actorInfo ? this.actorInfo.toJSON() : <any>undefined;
        if (this.actors) {
            data["actors"] = {};
            for (let key in this.actors) {
                if (this.actors.hasOwnProperty(key))
                    (<any>data["actors"])[key] = this.actors[key] ? this.actors[key].toJSON() : <any>undefined;
            }
        }
        data["actorServiceDown"] = this.actorServiceDown;
        return data;
    }
}

export interface IUserData {
    id?: string | undefined;
    applicationName?: string | undefined;
    organisationName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    voOrgCode?: string | undefined;
    isForeign?: boolean;
    isCitizen?: boolean;
    isOvo?: boolean;
    isAdmin?: boolean;
    scopes?: string[] | undefined;
    services?: AthumiService[] | undefined;
    actorInfo?: ActorDto | undefined;
    actors?: { [key: string]: ActorDto; } | undefined;
    actorServiceDown?: boolean;
}

export class PostPaidSession implements IPostPaidSession {
    sessionId?: string;
    transactionId?: string;

    constructor(data?: IPostPaidSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): PostPaidSession {
        data = typeof data === 'object' ? data : {};
        let result = new PostPaidSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["transactionId"] = this.transactionId;
        return data;
    }
}

export interface IPostPaidSession {
    sessionId?: string;
    transactionId?: string;
}

export class CreatePostPaidSession implements ICreatePostPaidSession {
    athumiService?: AthumiService;
    invoiceSettingId?: string | undefined;
    transactionId?: string;
    organisationName?: string;
    products?: ProductLineDto[];
    voOrgCode?: string;

    constructor(data?: ICreatePostPaidSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.athumiService = _data["athumiService"];
            this.invoiceSettingId = _data["invoiceSettingId"];
            this.transactionId = _data["transactionId"];
            this.organisationName = _data["organisationName"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductLineDto.fromJS(item));
            }
            this.voOrgCode = _data["voOrgCode"];
        }
    }

    static fromJS(data: any): CreatePostPaidSession {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePostPaidSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["athumiService"] = this.athumiService;
        data["invoiceSettingId"] = this.invoiceSettingId;
        data["transactionId"] = this.transactionId;
        data["organisationName"] = this.organisationName;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["voOrgCode"] = this.voOrgCode;
        return data;
    }
}

export interface ICreatePostPaidSession {
    athumiService?: AthumiService;
    invoiceSettingId?: string | undefined;
    transactionId?: string;
    organisationName?: string;
    products?: ProductLineDto[];
    voOrgCode?: string;
}

export class ProductLineDto implements IProductLineDto {
    productId?: ProductIdDto;
    invoiceLineTextValue?: string;
    extraInfo?: string | undefined;
    priceExclVat?: number;
    vatPercentage?: number;
    metaData?: ProductLineMetaDataDto[];

    constructor(data?: IProductLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] ? ProductIdDto.fromJS(_data["productId"]) : <any>undefined;
            this.invoiceLineTextValue = _data["invoiceLineTextValue"];
            this.extraInfo = _data["extraInfo"];
            this.priceExclVat = _data["priceExclVat"];
            this.vatPercentage = _data["vatPercentage"];
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [] as any;
                for (let item of _data["metaData"])
                    this.metaData!.push(ProductLineMetaDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId ? this.productId.toJSON() : <any>undefined;
        data["invoiceLineTextValue"] = this.invoiceLineTextValue;
        data["extraInfo"] = this.extraInfo;
        data["priceExclVat"] = this.priceExclVat;
        data["vatPercentage"] = this.vatPercentage;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductLineDto {
    productId?: ProductIdDto;
    invoiceLineTextValue?: string;
    extraInfo?: string | undefined;
    priceExclVat?: number;
    vatPercentage?: number;
    metaData?: ProductLineMetaDataDto[];
}

export class ProductIdDto implements IProductIdDto {
    id?: string;
    variantCode?: string | undefined;
    salesLineReferenceId?: string;

    constructor(data?: IProductIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.variantCode = _data["variantCode"];
            this.salesLineReferenceId = _data["salesLineReferenceId"];
        }
    }

    static fromJS(data: any): ProductIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["variantCode"] = this.variantCode;
        data["salesLineReferenceId"] = this.salesLineReferenceId;
        return data;
    }
}

export interface IProductIdDto {
    id?: string;
    variantCode?: string | undefined;
    salesLineReferenceId?: string;
}

export class ProductLineMetaDataDto implements IProductLineMetaDataDto {
    key?: string;
    value?: string;

    constructor(data?: IProductLineMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProductLineMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLineMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IProductLineMetaDataDto {
    key?: string;
    value?: string;
}

export class SelfBillingSession implements ISelfBillingSession {
    sessionId?: string;
    transactionId?: string;

    constructor(data?: ISelfBillingSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): SelfBillingSession {
        data = typeof data === 'object' ? data : {};
        let result = new SelfBillingSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["transactionId"] = this.transactionId;
        return data;
    }
}

export interface ISelfBillingSession {
    sessionId?: string;
    transactionId?: string;
}

export class CreateSelfBillingSession implements ICreateSelfBillingSession {
    athumiService?: AthumiService;
    transactionId?: string;
    organisationName?: string;
    products?: ProductLineDto[];
    voOrgCode?: string;

    constructor(data?: ICreateSelfBillingSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.athumiService = _data["athumiService"];
            this.transactionId = _data["transactionId"];
            this.organisationName = _data["organisationName"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductLineDto.fromJS(item));
            }
            this.voOrgCode = _data["voOrgCode"];
        }
    }

    static fromJS(data: any): CreateSelfBillingSession {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSelfBillingSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["athumiService"] = this.athumiService;
        data["transactionId"] = this.transactionId;
        data["organisationName"] = this.organisationName;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["voOrgCode"] = this.voOrgCode;
        return data;
    }
}

export interface ICreateSelfBillingSession {
    athumiService?: AthumiService;
    transactionId?: string;
    organisationName?: string;
    products?: ProductLineDto[];
    voOrgCode?: string;
}

export class InvoicesDto implements IInvoicesDto {
    invoices?: Invoice[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;
    downloadUrl?: string;

    constructor(data?: IInvoicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(Invoice.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any): InvoicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface IInvoicesDto {
    invoices?: Invoice[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;
    downloadUrl?: string;
}

export class Invoice implements IInvoice {
    documentDate?: string | undefined;
    paymentMethod?: PaymentMethod;
    documentType?: DocumentType;
    totalPrice?: number;
    directPdfUrl?: string | undefined;
    directCsvUrl?: string | undefined;
    invoiceNumber?: string;
    customerReference?: string;
    actorName?: string;
    service?: AthumiService;
    invoiceVatNumber?: string;
    paid?: boolean;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentDate = _data["documentDate"];
            this.paymentMethod = _data["paymentMethod"];
            this.documentType = _data["documentType"];
            this.totalPrice = _data["totalPrice"];
            this.directPdfUrl = _data["directPdfUrl"];
            this.directCsvUrl = _data["directCsvUrl"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.customerReference = _data["customerReference"];
            this.actorName = _data["actorName"];
            this.service = _data["service"];
            this.invoiceVatNumber = _data["invoiceVatNumber"];
            this.paid = _data["paid"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentDate"] = this.documentDate;
        data["paymentMethod"] = this.paymentMethod;
        data["documentType"] = this.documentType;
        data["totalPrice"] = this.totalPrice;
        data["directPdfUrl"] = this.directPdfUrl;
        data["directCsvUrl"] = this.directCsvUrl;
        data["invoiceNumber"] = this.invoiceNumber;
        data["customerReference"] = this.customerReference;
        data["actorName"] = this.actorName;
        data["service"] = this.service;
        data["invoiceVatNumber"] = this.invoiceVatNumber;
        data["paid"] = this.paid;
        return data;
    }
}

export interface IInvoice {
    documentDate?: string | undefined;
    paymentMethod?: PaymentMethod;
    documentType?: DocumentType;
    totalPrice?: number;
    directPdfUrl?: string | undefined;
    directCsvUrl?: string | undefined;
    invoiceNumber?: string;
    customerReference?: string;
    actorName?: string;
    service?: AthumiService;
    invoiceVatNumber?: string;
    paid?: boolean;
}

export enum PaymentMethod {
    None = "None",
    Invoice = "Invoice",
    Online = "Online",
    Credits = "Credits",
    InvoiceFedNot = "InvoiceFedNot",
}

export enum DocumentType {
    Invoice = "Invoice",
    PurchaseInvoice = "PurchaseInvoice",
    PaymentRequest = "PaymentRequest",
    PaymentProof = "PaymentProof",
}

export class InvoicesQuery implements IInvoicesQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    docNr?: string | undefined;
    customerReference?: string | undefined;
    actorId?: string;
    page?: number | undefined;
    pageSize?: number | undefined;
    orderBy?: string | undefined;
    orderDirection?: OrderDirection | undefined;

    constructor(data?: IInvoicesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.docNr = _data["docNr"];
            this.customerReference = _data["customerReference"];
            this.actorId = _data["actorId"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
        }
    }

    static fromJS(data: any): InvoicesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["docNr"] = this.docNr;
        data["customerReference"] = this.customerReference;
        data["actorId"] = this.actorId;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        return data;
    }
}

export interface IInvoicesQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    docNr?: string | undefined;
    customerReference?: string | undefined;
    actorId?: string;
    page?: number | undefined;
    pageSize?: number | undefined;
    orderBy?: string | undefined;
    orderDirection?: OrderDirection | undefined;
}

export enum OrderDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export abstract class Stream implements IStream {
    canRead?: boolean;
    canWrite?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canRead = _data["canRead"];
            this.canWrite = _data["canWrite"];
            this.canSeek = _data["canSeek"];
            this.canTimeout = _data["canTimeout"];
            this.length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }
}

export interface IStream {
    canRead?: boolean;
    canWrite?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;
}

export enum InvoiceFileType {
    Pdf = "Pdf",
    Csv = "Csv",
}

export class InvoiceRoundDto implements IInvoiceRoundDto {
    invoiceRoundId?: string;
    date?: string;
    startDate?: string;
    endDate?: string;
    service?: AthumiService2;
    state?: string | undefined;
    type?: string | undefined;
    invoiceCount?: number;

    constructor(data?: IInvoiceRoundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceRoundId = _data["invoiceRoundId"];
            this.date = _data["date"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.service = _data["service"];
            this.state = _data["state"];
            this.type = _data["type"];
            this.invoiceCount = _data["invoiceCount"];
        }
    }

    static fromJS(data: any): InvoiceRoundDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRoundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceRoundId"] = this.invoiceRoundId;
        data["date"] = this.date;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["service"] = this.service;
        data["state"] = this.state;
        data["type"] = this.type;
        data["invoiceCount"] = this.invoiceCount;
        return data;
    }
}

export interface IInvoiceRoundDto {
    invoiceRoundId?: string;
    date?: string;
    startDate?: string;
    endDate?: string;
    service?: AthumiService2;
    state?: string | undefined;
    type?: string | undefined;
    invoiceCount?: number;
}

export enum AthumiService2 {
    All = "All",
    Klip = "Klip",
    Vip = "Vip",
    ELys = "ELys",
}

export class InvoiceSettings implements IInvoiceSettings {
    invoiceSettingsId?: string;
    invoiceReference?: string | undefined;
    athumiService?: AthumiService;
    forTheAttentionOf?: string | undefined;

    constructor(data?: IInvoiceSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceSettingsId = _data["invoiceSettingsId"];
            this.invoiceReference = _data["invoiceReference"];
            this.athumiService = _data["athumiService"];
            this.forTheAttentionOf = _data["forTheAttentionOf"];
        }
    }

    static fromJS(data: any): InvoiceSettings {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceSettingsId"] = this.invoiceSettingsId;
        data["invoiceReference"] = this.invoiceReference;
        data["athumiService"] = this.athumiService;
        data["forTheAttentionOf"] = this.forTheAttentionOf;
        return data;
    }
}

export interface IInvoiceSettings {
    invoiceSettingsId?: string;
    invoiceReference?: string | undefined;
    athumiService?: AthumiService;
    forTheAttentionOf?: string | undefined;
}

export class UpdateInvoiceSettingsRequest implements IUpdateInvoiceSettingsRequest {
    invoiceReference?: string | undefined;
    forTheAttentionOf?: string | undefined;

    constructor(data?: IUpdateInvoiceSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceReference = _data["invoiceReference"];
            this.forTheAttentionOf = _data["forTheAttentionOf"];
        }
    }

    static fromJS(data: any): UpdateInvoiceSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceReference"] = this.invoiceReference;
        data["forTheAttentionOf"] = this.forTheAttentionOf;
        return data;
    }
}

export interface IUpdateInvoiceSettingsRequest {
    invoiceReference?: string | undefined;
    forTheAttentionOf?: string | undefined;
}

export class PaymentProviderInfo implements IPaymentProviderInfo {
    sessionId!: string;
    sessionType!: SessionType;
    totalAmountInclVat!: number;

    constructor(data?: IPaymentProviderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.sessionType = _data["sessionType"];
            this.totalAmountInclVat = _data["totalAmountInclVat"];
        }
    }

    static fromJS(data: any): PaymentProviderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProviderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["sessionType"] = this.sessionType;
        data["totalAmountInclVat"] = this.totalAmountInclVat;
        return data;
    }
}

export interface IPaymentProviderInfo {
    sessionId: string;
    sessionType: SessionType;
    totalAmountInclVat: number;
}

export enum SessionType {
    All = "All",
    Payment = "Payment",
    TopUp = "TopUp",
    EditActor = "EditActor",
    PostPaid = "PostPaid",
    SelfBilling = "SelfBilling",
}

export class SessionsDto implements ISessionsDto {
    sessions?: SessionDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;

    constructor(data?: ISessionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(SessionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): SessionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface ISessionsDto {
    sessions?: SessionDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;
}

export class SessionDto implements ISessionDto {
    sessionId?: string;
    transactionId?: string;
    creationTimeUtc?: string;
    state?: SessionState;
    type?: SessionType;
    paymentMethod?: PaymentMethod;
    service?: AthumiService;
    actorIdentifier?: string;
    actorName?: string;

    constructor(data?: ISessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.transactionId = _data["transactionId"];
            this.creationTimeUtc = _data["creationTimeUtc"];
            this.state = _data["state"];
            this.type = _data["type"];
            this.paymentMethod = _data["paymentMethod"];
            this.service = _data["service"];
            this.actorIdentifier = _data["actorIdentifier"];
            this.actorName = _data["actorName"];
        }
    }

    static fromJS(data: any): SessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["transactionId"] = this.transactionId;
        data["creationTimeUtc"] = this.creationTimeUtc;
        data["state"] = this.state;
        data["type"] = this.type;
        data["paymentMethod"] = this.paymentMethod;
        data["service"] = this.service;
        data["actorIdentifier"] = this.actorIdentifier;
        data["actorName"] = this.actorName;
        return data;
    }
}

export interface ISessionDto {
    sessionId?: string;
    transactionId?: string;
    creationTimeUtc?: string;
    state?: SessionState;
    type?: SessionType;
    paymentMethod?: PaymentMethod;
    service?: AthumiService;
    actorIdentifier?: string;
    actorName?: string;
}

export enum SessionState {
    All = "All",
    Pending = "Pending",
    Submitted = "Submitted",
    PaymentSuccessful = "PaymentSuccessful",
    PaymentUnsuccessful = "PaymentUnsuccessful",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Expired = "Expired",
}

export class SearchSessionsQuery implements ISearchSessionsQuery {
    transactionId?: string | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    state?: SessionState | undefined;
    paymentMethod?: PaymentMethod | undefined;
    type?: SessionType | undefined;
    service?: AthumiService | undefined;
    actorIdentifier?: string | undefined;
    actorName?: string | undefined;
    sessionDetail?: string | undefined;
    documentNumber?: string | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    orderDirection?: OrderDirection | undefined;

    constructor(data?: ISearchSessionsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.state = _data["state"];
            this.paymentMethod = _data["paymentMethod"];
            this.type = _data["type"];
            this.service = _data["service"];
            this.actorIdentifier = _data["actorIdentifier"];
            this.actorName = _data["actorName"];
            this.sessionDetail = _data["sessionDetail"];
            this.documentNumber = _data["documentNumber"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.orderDirection = _data["orderDirection"];
        }
    }

    static fromJS(data: any): SearchSessionsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSessionsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["state"] = this.state;
        data["paymentMethod"] = this.paymentMethod;
        data["type"] = this.type;
        data["service"] = this.service;
        data["actorIdentifier"] = this.actorIdentifier;
        data["actorName"] = this.actorName;
        data["sessionDetail"] = this.sessionDetail;
        data["documentNumber"] = this.documentNumber;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["orderDirection"] = this.orderDirection;
        return data;
    }
}

export interface ISearchSessionsQuery {
    transactionId?: string | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    state?: SessionState | undefined;
    paymentMethod?: PaymentMethod | undefined;
    type?: SessionType | undefined;
    service?: AthumiService | undefined;
    actorIdentifier?: string | undefined;
    actorName?: string | undefined;
    sessionDetail?: string | undefined;
    documentNumber?: string | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    orderDirection?: OrderDirection | undefined;
}

export class SessionDetailDto implements ISessionDetailDto {
    sessionId?: string;
    transactionId?: string;
    invoiceSettingId?: string | undefined;
    documentTransactionId?: string | undefined;
    creationTimeUtc?: string;
    submittedTimeUtc?: string | undefined;
    closedTimeUtc?: string | undefined;
    state?: SessionState;
    type?: SessionType;
    service?: AthumiService;
    callbackUrl?: string;
    paymentDetails?: PaymentSessionDetailDto;
    actor?: SessionActorDto;
    invoice?: SessionDetailInvoiceDto;
    isFedNot?: boolean;

    constructor(data?: ISessionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.transactionId = _data["transactionId"];
            this.invoiceSettingId = _data["invoiceSettingId"];
            this.documentTransactionId = _data["documentTransactionId"];
            this.creationTimeUtc = _data["creationTimeUtc"];
            this.submittedTimeUtc = _data["submittedTimeUtc"];
            this.closedTimeUtc = _data["closedTimeUtc"];
            this.state = _data["state"];
            this.type = _data["type"];
            this.service = _data["service"];
            this.callbackUrl = _data["callbackUrl"];
            this.paymentDetails = _data["paymentDetails"] ? PaymentSessionDetailDto.fromJS(_data["paymentDetails"]) : <any>undefined;
            this.actor = _data["actor"] ? SessionActorDto.fromJS(_data["actor"]) : <any>undefined;
            this.invoice = _data["invoice"] ? SessionDetailInvoiceDto.fromJS(_data["invoice"]) : <any>undefined;
            this.isFedNot = _data["isFedNot"];
        }
    }

    static fromJS(data: any): SessionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["transactionId"] = this.transactionId;
        data["invoiceSettingId"] = this.invoiceSettingId;
        data["documentTransactionId"] = this.documentTransactionId;
        data["creationTimeUtc"] = this.creationTimeUtc;
        data["submittedTimeUtc"] = this.submittedTimeUtc;
        data["closedTimeUtc"] = this.closedTimeUtc;
        data["state"] = this.state;
        data["type"] = this.type;
        data["service"] = this.service;
        data["callbackUrl"] = this.callbackUrl;
        data["paymentDetails"] = this.paymentDetails ? this.paymentDetails.toJSON() : <any>undefined;
        data["actor"] = this.actor ? this.actor.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["isFedNot"] = this.isFedNot;
        return data;
    }
}

export interface ISessionDetailDto {
    sessionId?: string;
    transactionId?: string;
    invoiceSettingId?: string | undefined;
    documentTransactionId?: string | undefined;
    creationTimeUtc?: string;
    submittedTimeUtc?: string | undefined;
    closedTimeUtc?: string | undefined;
    state?: SessionState;
    type?: SessionType;
    service?: AthumiService;
    callbackUrl?: string;
    paymentDetails?: PaymentSessionDetailDto;
    actor?: SessionActorDto;
    invoice?: SessionDetailInvoiceDto;
    isFedNot?: boolean;
}

export class PaymentSessionDetailDto implements IPaymentSessionDetailDto {
    paymentMethod?: PaymentMethod | undefined;
    products?: ProductDto[] | undefined;
    topUpAmount?: number | undefined;
    paymentServiceProviderLink?: string | undefined;
    paymentServiceProviderMerchantReference?: string | undefined;

    constructor(data?: IPaymentSessionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethod = _data["paymentMethod"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductDto.fromJS(item));
            }
            this.topUpAmount = _data["topUpAmount"];
            this.paymentServiceProviderLink = _data["paymentServiceProviderLink"];
            this.paymentServiceProviderMerchantReference = _data["paymentServiceProviderMerchantReference"];
        }
    }

    static fromJS(data: any): PaymentSessionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSessionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["topUpAmount"] = this.topUpAmount;
        data["paymentServiceProviderLink"] = this.paymentServiceProviderLink;
        data["paymentServiceProviderMerchantReference"] = this.paymentServiceProviderMerchantReference;
        return data;
    }
}

export interface IPaymentSessionDetailDto {
    paymentMethod?: PaymentMethod | undefined;
    products?: ProductDto[] | undefined;
    topUpAmount?: number | undefined;
    paymentServiceProviderLink?: string | undefined;
    paymentServiceProviderMerchantReference?: string | undefined;
}

export class ProductDto implements IProductDto {
    salesLineReferenceId?: string;
    productId?: string;
    variantCode?: string;
    description?: string;
    amountExclVat?: number;
    vatRate?: number;
    amountInclVat?: number;
    metaData?: { [key: string]: string; };

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesLineReferenceId = _data["salesLineReferenceId"];
            this.productId = _data["productId"];
            this.variantCode = _data["variantCode"];
            this.description = _data["description"];
            this.amountExclVat = _data["amountExclVat"];
            this.vatRate = _data["vatRate"];
            this.amountInclVat = _data["amountInclVat"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesLineReferenceId"] = this.salesLineReferenceId;
        data["productId"] = this.productId;
        data["variantCode"] = this.variantCode;
        data["description"] = this.description;
        data["amountExclVat"] = this.amountExclVat;
        data["vatRate"] = this.vatRate;
        data["amountInclVat"] = this.amountInclVat;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = (<any>this.metaData)[key];
            }
        }
        return data;
    }
}

export interface IProductDto {
    salesLineReferenceId?: string;
    productId?: string;
    variantCode?: string;
    description?: string;
    amountExclVat?: number;
    vatRate?: number;
    amountInclVat?: number;
    metaData?: { [key: string]: string; };
}

export class SessionActorDto implements ISessionActorDto {
    identifier?: string | undefined;
    name?: string | undefined;
    actorId?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    bus?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    countryRegionCode?: string | undefined;
    vatNumber?: string | undefined;
    peppolCode?: string | undefined;
    peppolActive?: boolean | undefined;
    emails?: string[] | undefined;

    constructor(data?: ISessionActorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.actorId = _data["actorId"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryRegionCode = _data["countryRegionCode"];
            this.vatNumber = _data["vatNumber"];
            this.peppolCode = _data["peppolCode"];
            this.peppolActive = _data["peppolActive"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): SessionActorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionActorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["actorId"] = this.actorId;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryRegionCode"] = this.countryRegionCode;
        data["vatNumber"] = this.vatNumber;
        data["peppolCode"] = this.peppolCode;
        data["peppolActive"] = this.peppolActive;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface ISessionActorDto {
    identifier?: string | undefined;
    name?: string | undefined;
    actorId?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    bus?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    countryRegionCode?: string | undefined;
    vatNumber?: string | undefined;
    peppolCode?: string | undefined;
    peppolActive?: boolean | undefined;
    emails?: string[] | undefined;
}

export class SessionDetailInvoiceDto implements ISessionDetailInvoiceDto {
    invoiceNumber?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceAmount?: number | undefined;
    pdfUrl?: string;
    csvUrl?: string;
    content?: string;
    customerReference?: string;
    paid?: boolean;
    documentType?: DocumentType;

    constructor(data?: ISessionDetailInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.pdfUrl = _data["pdfUrl"];
            this.csvUrl = _data["csvUrl"];
            this.content = _data["content"];
            this.customerReference = _data["customerReference"];
            this.paid = _data["paid"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): SessionDetailInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionDetailInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate;
        data["invoiceAmount"] = this.invoiceAmount;
        data["pdfUrl"] = this.pdfUrl;
        data["csvUrl"] = this.csvUrl;
        data["content"] = this.content;
        data["customerReference"] = this.customerReference;
        data["paid"] = this.paid;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface ISessionDetailInvoiceDto {
    invoiceNumber?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceAmount?: number | undefined;
    pdfUrl?: string;
    csvUrl?: string;
    content?: string;
    customerReference?: string;
    paid?: boolean;
    documentType?: DocumentType;
}

export class MessageQueueCountDto implements IMessageQueueCountDto {
    name!: string;
    activeCount!: number;
    errorCount!: number;
    serviceHealth!: ServiceHealth;

    constructor(data?: IMessageQueueCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceHealth = new ServiceHealth();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.activeCount = _data["activeCount"];
            this.errorCount = _data["errorCount"];
            this.serviceHealth = _data["serviceHealth"] ? ServiceHealth.fromJS(_data["serviceHealth"]) : new ServiceHealth();
        }
    }

    static fromJS(data: any): MessageQueueCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageQueueCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["activeCount"] = this.activeCount;
        data["errorCount"] = this.errorCount;
        data["serviceHealth"] = this.serviceHealth ? this.serviceHealth.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMessageQueueCountDto {
    name: string;
    activeCount: number;
    errorCount: number;
    serviceHealth: ServiceHealth;
}

export class ServiceHealth implements IServiceHealth {
    status?: ServiceHealthStatus;
    subServices?: SubServiceHealthStatus[];

    constructor(data?: IServiceHealth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["subServices"])) {
                this.subServices = [] as any;
                for (let item of _data["subServices"])
                    this.subServices!.push(SubServiceHealthStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceHealth {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceHealth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.subServices)) {
            data["subServices"] = [];
            for (let item of this.subServices)
                data["subServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceHealth {
    status?: ServiceHealthStatus;
    subServices?: SubServiceHealthStatus[];
}

export enum ServiceHealthStatus {
    Unknown = "Unknown",
    Healthy = "Healthy",
    Unhealthy = "Unhealthy",
}

export class SubServiceHealthStatus implements ISubServiceHealthStatus {
    name?: string;
    healthStatus?: ServiceHealthStatus;

    constructor(data?: ISubServiceHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.healthStatus = _data["healthStatus"];
        }
    }

    static fromJS(data: any): SubServiceHealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SubServiceHealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["healthStatus"] = this.healthStatus;
        return data;
    }
}

export interface ISubServiceHealthStatus {
    name?: string;
    healthStatus?: ServiceHealthStatus;
}

export class DashboardDto implements IDashboardDto {
    messageQueueCount!: MessageQueueCountDto[];
    pendingPaymentCount!: MessageQueueCountDto;
    submittedPaymentCount!: MessageQueueCountDto;
    submittedTopUpCount!: MessageQueueCountDto;
    anomalies!: AnomaliesDto;

    constructor(data?: IDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageQueueCount = [];
            this.pendingPaymentCount = new MessageQueueCountDto();
            this.submittedPaymentCount = new MessageQueueCountDto();
            this.submittedTopUpCount = new MessageQueueCountDto();
            this.anomalies = new AnomaliesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageQueueCount"])) {
                this.messageQueueCount = [] as any;
                for (let item of _data["messageQueueCount"])
                    this.messageQueueCount!.push(MessageQueueCountDto.fromJS(item));
            }
            this.pendingPaymentCount = _data["pendingPaymentCount"] ? MessageQueueCountDto.fromJS(_data["pendingPaymentCount"]) : new MessageQueueCountDto();
            this.submittedPaymentCount = _data["submittedPaymentCount"] ? MessageQueueCountDto.fromJS(_data["submittedPaymentCount"]) : new MessageQueueCountDto();
            this.submittedTopUpCount = _data["submittedTopUpCount"] ? MessageQueueCountDto.fromJS(_data["submittedTopUpCount"]) : new MessageQueueCountDto();
            this.anomalies = _data["anomalies"] ? AnomaliesDto.fromJS(_data["anomalies"]) : new AnomaliesDto();
        }
    }

    static fromJS(data: any): DashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageQueueCount)) {
            data["messageQueueCount"] = [];
            for (let item of this.messageQueueCount)
                data["messageQueueCount"].push(item.toJSON());
        }
        data["pendingPaymentCount"] = this.pendingPaymentCount ? this.pendingPaymentCount.toJSON() : <any>undefined;
        data["submittedPaymentCount"] = this.submittedPaymentCount ? this.submittedPaymentCount.toJSON() : <any>undefined;
        data["submittedTopUpCount"] = this.submittedTopUpCount ? this.submittedTopUpCount.toJSON() : <any>undefined;
        data["anomalies"] = this.anomalies ? this.anomalies.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardDto {
    messageQueueCount: MessageQueueCountDto[];
    pendingPaymentCount: MessageQueueCountDto;
    submittedPaymentCount: MessageQueueCountDto;
    submittedTopUpCount: MessageQueueCountDto;
    anomalies: AnomaliesDto;
}

export class AnomaliesDto implements IAnomaliesDto {
    sessionsWithoutInvoice!: number;

    constructor(data?: IAnomaliesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionsWithoutInvoice = _data["sessionsWithoutInvoice"];
        }
    }

    static fromJS(data: any): AnomaliesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnomaliesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionsWithoutInvoice"] = this.sessionsWithoutInvoice;
        return data;
    }
}

export interface IAnomaliesDto {
    sessionsWithoutInvoice: number;
}

export class AnomaliesDetailDto implements IAnomaliesDetailDto {
    sessionsWithoutInvoice!: AnomalyDto[];

    constructor(data?: IAnomaliesDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sessionsWithoutInvoice = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sessionsWithoutInvoice"])) {
                this.sessionsWithoutInvoice = [] as any;
                for (let item of _data["sessionsWithoutInvoice"])
                    this.sessionsWithoutInvoice!.push(AnomalyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnomaliesDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnomaliesDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sessionsWithoutInvoice)) {
            data["sessionsWithoutInvoice"] = [];
            for (let item of this.sessionsWithoutInvoice)
                data["sessionsWithoutInvoice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnomaliesDetailDto {
    sessionsWithoutInvoice: AnomalyDto[];
}

export class AnomalyDto implements IAnomalyDto {
    sessionId!: string;
    creationTimeUtc!: string;
    sessionType!: SessionType;

    constructor(data?: IAnomalyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.creationTimeUtc = _data["creationTimeUtc"];
            this.sessionType = _data["sessionType"];
        }
    }

    static fromJS(data: any): AnomalyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnomalyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["creationTimeUtc"] = this.creationTimeUtc;
        data["sessionType"] = this.sessionType;
        return data;
    }
}

export interface IAnomalyDto {
    sessionId: string;
    creationTimeUtc: string;
    sessionType: SessionType;
}

export class HealthCheckDto implements IHealthCheckDto {
    name!: string;
    serviceHealth!: ServiceHealth;

    constructor(data?: IHealthCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceHealth = new ServiceHealth();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.serviceHealth = _data["serviceHealth"] ? ServiceHealth.fromJS(_data["serviceHealth"]) : new ServiceHealth();
        }
    }

    static fromJS(data: any): HealthCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serviceHealth"] = this.serviceHealth ? this.serviceHealth.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthCheckDto {
    name: string;
    serviceHealth: ServiceHealth;
}

export class DeadLetterMessage implements IDeadLetterMessage {
    properties?: MessageProperties;
    payloadRaw?: string;
    payloadEncoding?: string;

    constructor(data?: IDeadLetterMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.properties = _data["properties"] ? MessageProperties.fromJS(_data["properties"]) : <any>undefined;
            this.payloadRaw = _data["payloadRaw"];
            this.payloadEncoding = _data["payloadEncoding"];
        }
    }

    static fromJS(data: any): DeadLetterMessage {
        data = typeof data === 'object' ? data : {};
        let result = new DeadLetterMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["payloadRaw"] = this.payloadRaw;
        data["payloadEncoding"] = this.payloadEncoding;
        return data;
    }
}

export interface IDeadLetterMessage {
    properties?: MessageProperties;
    payloadRaw?: string;
    payloadEncoding?: string;
}

export class MessageProperties implements IMessageProperties {
    messageId?: string;
    correlationId?: string;
    headers?: MessageHeaders;
    contentType?: string;

    constructor(data?: IMessageProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.correlationId = _data["correlationId"];
            this.headers = _data["headers"] ? MessageHeaders.fromJS(_data["headers"]) : <any>undefined;
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): MessageProperties {
        data = typeof data === 'object' ? data : {};
        let result = new MessageProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["correlationId"] = this.correlationId;
        data["headers"] = this.headers ? this.headers.toJSON() : <any>undefined;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IMessageProperties {
    messageId?: string;
    correlationId?: string;
    headers?: MessageHeaders;
    contentType?: string;
}

export class MessageHeaders implements IMessageHeaders {
    faultExceptionType?: string;
    faultMessage?: string;
    faultMessageType?: string;
    faultStackTrace?: string;
    faultTimestamp?: string;

    constructor(data?: IMessageHeaders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faultExceptionType = _data["faultExceptionType"];
            this.faultMessage = _data["faultMessage"];
            this.faultMessageType = _data["faultMessageType"];
            this.faultStackTrace = _data["faultStackTrace"];
            this.faultTimestamp = _data["faultTimestamp"];
        }
    }

    static fromJS(data: any): MessageHeaders {
        data = typeof data === 'object' ? data : {};
        let result = new MessageHeaders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faultExceptionType"] = this.faultExceptionType;
        data["faultMessage"] = this.faultMessage;
        data["faultMessageType"] = this.faultMessageType;
        data["faultStackTrace"] = this.faultStackTrace;
        data["faultTimestamp"] = this.faultTimestamp;
        return data;
    }
}

export interface IMessageHeaders {
    faultExceptionType?: string;
    faultMessage?: string;
    faultMessageType?: string;
    faultStackTrace?: string;
    faultTimestamp?: string;
}

export class OperationsActorDto implements IOperationsActorDto {
    actorType?: ActorType;
    identifier?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    actorId?: string | undefined;
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    countryRegionCode?: string;
    vatNumber?: string;
    peppolCode?: string;
    peppolActive?: boolean | undefined;
    customerNumber?: string;
    serviceInfo?: OperationsActorServiceInfo[] | undefined;

    constructor(data?: IOperationsActorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actorType = _data["actorType"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.actorId = _data["actorId"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryRegionCode = _data["countryRegionCode"];
            this.vatNumber = _data["vatNumber"];
            this.peppolCode = _data["peppolCode"];
            this.peppolActive = _data["peppolActive"];
            this.customerNumber = _data["customerNumber"];
            if (Array.isArray(_data["serviceInfo"])) {
                this.serviceInfo = [] as any;
                for (let item of _data["serviceInfo"])
                    this.serviceInfo!.push(OperationsActorServiceInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperationsActorDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationsActorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actorType"] = this.actorType;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["actorId"] = this.actorId;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryRegionCode"] = this.countryRegionCode;
        data["vatNumber"] = this.vatNumber;
        data["peppolCode"] = this.peppolCode;
        data["peppolActive"] = this.peppolActive;
        data["customerNumber"] = this.customerNumber;
        if (Array.isArray(this.serviceInfo)) {
            data["serviceInfo"] = [];
            for (let item of this.serviceInfo)
                data["serviceInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOperationsActorDto {
    actorType?: ActorType;
    identifier?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    actorId?: string | undefined;
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    countryRegionCode?: string;
    vatNumber?: string;
    peppolCode?: string;
    peppolActive?: boolean | undefined;
    customerNumber?: string;
    serviceInfo?: OperationsActorServiceInfo[] | undefined;
}

export enum ActorType {
    Citizen = "Citizen",
    ForeignOrganisation = "ForeignOrganisation",
    Organisation = "Organisation",
    GovernmentAgency = "GovernmentAgency",
}

export class OperationsActorServiceInfo implements IOperationsActorServiceInfo {
    actorId?: string | undefined;
    service?: AthumiService;
    amount?: number | undefined;
    emails?: string[];

    constructor(data?: IOperationsActorServiceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actorId = _data["actorId"];
            this.service = _data["service"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): OperationsActorServiceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OperationsActorServiceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actorId"] = this.actorId;
        data["service"] = this.service;
        data["amount"] = this.amount;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IOperationsActorServiceInfo {
    actorId?: string | undefined;
    service?: AthumiService;
    amount?: number | undefined;
    emails?: string[];
}

export class OperationsActorInfo implements IOperationsActorInfo {
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    countryCode?: string;
    vatNumber?: string | undefined;

    constructor(data?: IOperationsActorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.vatNumber = _data["vatNumber"];
        }
    }

    static fromJS(data: any): OperationsActorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OperationsActorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["vatNumber"] = this.vatNumber;
        return data;
    }
}

export interface IOperationsActorInfo {
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    countryCode?: string;
    vatNumber?: string | undefined;
}

export class ActorAuditLogDto implements IActorAuditLogDto {
    actorAuditLogId?: string;
    actorId?: string;
    actorType?: ActorType;
    identifier?: string;
    athumiService?: AthumiService;
    changes?: { [key: string]: any; } | undefined;
    auditDate?: string | undefined;
    userId?: string | undefined;
    correlationId?: string | undefined;

    constructor(data?: IActorAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actorAuditLogId = _data["actorAuditLogId"];
            this.actorId = _data["actorId"];
            this.actorType = _data["actorType"];
            this.identifier = _data["identifier"];
            this.athumiService = _data["athumiService"];
            if (_data["changes"]) {
                this.changes = {} as any;
                for (let key in _data["changes"]) {
                    if (_data["changes"].hasOwnProperty(key))
                        (<any>this.changes)![key] = _data["changes"][key];
                }
            }
            this.auditDate = _data["auditDate"];
            this.userId = _data["userId"];
            this.correlationId = _data["correlationId"];
        }
    }

    static fromJS(data: any): ActorAuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActorAuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actorAuditLogId"] = this.actorAuditLogId;
        data["actorId"] = this.actorId;
        data["actorType"] = this.actorType;
        data["identifier"] = this.identifier;
        data["athumiService"] = this.athumiService;
        if (this.changes) {
            data["changes"] = {};
            for (let key in this.changes) {
                if (this.changes.hasOwnProperty(key))
                    (<any>data["changes"])[key] = (<any>this.changes)[key];
            }
        }
        data["auditDate"] = this.auditDate;
        data["userId"] = this.userId;
        data["correlationId"] = this.correlationId;
        return data;
    }
}

export interface IActorAuditLogDto {
    actorAuditLogId?: string;
    actorId?: string;
    actorType?: ActorType;
    identifier?: string;
    athumiService?: AthumiService;
    changes?: { [key: string]: any; } | undefined;
    auditDate?: string | undefined;
    userId?: string | undefined;
    correlationId?: string | undefined;
}

export class AllInvoicesQuery implements IAllInvoicesQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    docNr?: string | undefined;
    customerReference?: string | undefined;
    service?: AthumiService;
    documentType?: DocumentType | undefined;
    actorId?: string | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;

    constructor(data?: IAllInvoicesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.docNr = _data["docNr"];
            this.customerReference = _data["customerReference"];
            this.service = _data["service"];
            this.documentType = _data["documentType"];
            this.actorId = _data["actorId"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): AllInvoicesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AllInvoicesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["docNr"] = this.docNr;
        data["customerReference"] = this.customerReference;
        data["service"] = this.service;
        data["documentType"] = this.documentType;
        data["actorId"] = this.actorId;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IAllInvoicesQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    docNr?: string | undefined;
    customerReference?: string | undefined;
    service?: AthumiService;
    documentType?: DocumentType | undefined;
    actorId?: string | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
}

export class PaymentRequestInvoicesQuery implements IPaymentRequestInvoicesQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    docNr?: string | undefined;
    service?: AthumiService;
    page?: number | undefined;
    pageSize?: number | undefined;

    constructor(data?: IPaymentRequestInvoicesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.docNr = _data["docNr"];
            this.service = _data["service"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PaymentRequestInvoicesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestInvoicesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["docNr"] = this.docNr;
        data["service"] = this.service;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPaymentRequestInvoicesQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    docNr?: string | undefined;
    service?: AthumiService;
    page?: number | undefined;
    pageSize?: number | undefined;
}

export class PurchaseInvoicesDto implements IPurchaseInvoicesDto {
    invoices?: PurchaseInvoice[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;
    downloadUrl?: string;

    constructor(data?: IPurchaseInvoicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(PurchaseInvoice.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any): PurchaseInvoicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseInvoicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface IPurchaseInvoicesDto {
    invoices?: PurchaseInvoice[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;
    downloadUrl?: string;
}

export class PurchaseInvoice implements IPurchaseInvoice {
    submitTimestamp?: string | undefined;
    documentType?: DocumentType;
    totalPrice?: number;
    directPdfUrl?: string | undefined;
    directCsvUrl?: string | undefined;
    invoiceNumber?: string;
    actorName?: string;
    service?: AthumiService;
    paid?: boolean;

    constructor(data?: IPurchaseInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitTimestamp = _data["submitTimestamp"];
            this.documentType = _data["documentType"];
            this.totalPrice = _data["totalPrice"];
            this.directPdfUrl = _data["directPdfUrl"];
            this.directCsvUrl = _data["directCsvUrl"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.actorName = _data["actorName"];
            this.service = _data["service"];
            this.paid = _data["paid"];
        }
    }

    static fromJS(data: any): PurchaseInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitTimestamp"] = this.submitTimestamp;
        data["documentType"] = this.documentType;
        data["totalPrice"] = this.totalPrice;
        data["directPdfUrl"] = this.directPdfUrl;
        data["directCsvUrl"] = this.directCsvUrl;
        data["invoiceNumber"] = this.invoiceNumber;
        data["actorName"] = this.actorName;
        data["service"] = this.service;
        data["paid"] = this.paid;
        return data;
    }
}

export interface IPurchaseInvoice {
    submitTimestamp?: string | undefined;
    documentType?: DocumentType;
    totalPrice?: number;
    directPdfUrl?: string | undefined;
    directCsvUrl?: string | undefined;
    invoiceNumber?: string;
    actorName?: string;
    service?: AthumiService;
    paid?: boolean;
}

export class AllPurchaseInvoicesQuery implements IAllPurchaseInvoicesQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    docNr?: string | undefined;
    service?: AthumiService | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;

    constructor(data?: IAllPurchaseInvoicesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.docNr = _data["docNr"];
            this.service = _data["service"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): AllPurchaseInvoicesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AllPurchaseInvoicesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["docNr"] = this.docNr;
        data["service"] = this.service;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IAllPurchaseInvoicesQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    docNr?: string | undefined;
    service?: AthumiService | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
}

export class PaymentSession implements IPaymentSession {
    sessionId!: string;
    service!: AthumiService;
    sessionState!: SessionState;
    creationTimeUtc!: string;
    submitTimeUtc?: string | undefined;
    closedTimeUtc?: string | undefined;
    transactionId?: string;
    companyName!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    bus?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    countryRegionCode?: string | undefined;
    vatNumber?: string | undefined;
    currentServiceSaldo?: number | undefined;
    emails?: string[] | undefined;
    productLines!: ProductLine[];
    paymentLink!: string;
    totalAmountExclVat!: number;
    totalAmountInclVat!: number;
    totalVat!: number;
    vatByRate!: { [key: string]: number; };
    callbackUrl!: string;
    sessionLocked?: boolean;

    constructor(data?: IPaymentSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productLines = [];
            this.vatByRate = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.service = _data["service"];
            this.sessionState = _data["sessionState"];
            this.creationTimeUtc = _data["creationTimeUtc"];
            this.submitTimeUtc = _data["submitTimeUtc"];
            this.closedTimeUtc = _data["closedTimeUtc"];
            this.transactionId = _data["transactionId"];
            this.companyName = _data["companyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryRegionCode = _data["countryRegionCode"];
            this.vatNumber = _data["vatNumber"];
            this.currentServiceSaldo = _data["currentServiceSaldo"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            if (Array.isArray(_data["productLines"])) {
                this.productLines = [] as any;
                for (let item of _data["productLines"])
                    this.productLines!.push(ProductLine.fromJS(item));
            }
            this.paymentLink = _data["paymentLink"];
            this.totalAmountExclVat = _data["totalAmountExclVat"];
            this.totalAmountInclVat = _data["totalAmountInclVat"];
            this.totalVat = _data["totalVat"];
            if (_data["vatByRate"]) {
                this.vatByRate = {} as any;
                for (let key in _data["vatByRate"]) {
                    if (_data["vatByRate"].hasOwnProperty(key))
                        (<any>this.vatByRate)![key] = _data["vatByRate"][key];
                }
            }
            this.callbackUrl = _data["callbackUrl"];
            this.sessionLocked = _data["sessionLocked"];
        }
    }

    static fromJS(data: any): PaymentSession {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["service"] = this.service;
        data["sessionState"] = this.sessionState;
        data["creationTimeUtc"] = this.creationTimeUtc;
        data["submitTimeUtc"] = this.submitTimeUtc;
        data["closedTimeUtc"] = this.closedTimeUtc;
        data["transactionId"] = this.transactionId;
        data["companyName"] = this.companyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryRegionCode"] = this.countryRegionCode;
        data["vatNumber"] = this.vatNumber;
        data["currentServiceSaldo"] = this.currentServiceSaldo;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        if (Array.isArray(this.productLines)) {
            data["productLines"] = [];
            for (let item of this.productLines)
                data["productLines"].push(item.toJSON());
        }
        data["paymentLink"] = this.paymentLink;
        data["totalAmountExclVat"] = this.totalAmountExclVat;
        data["totalAmountInclVat"] = this.totalAmountInclVat;
        data["totalVat"] = this.totalVat;
        if (this.vatByRate) {
            data["vatByRate"] = {};
            for (let key in this.vatByRate) {
                if (this.vatByRate.hasOwnProperty(key))
                    (<any>data["vatByRate"])[key] = (<any>this.vatByRate)[key];
            }
        }
        data["callbackUrl"] = this.callbackUrl;
        data["sessionLocked"] = this.sessionLocked;
        return data;
    }
}

export interface IPaymentSession {
    sessionId: string;
    service: AthumiService;
    sessionState: SessionState;
    creationTimeUtc: string;
    submitTimeUtc?: string | undefined;
    closedTimeUtc?: string | undefined;
    transactionId?: string;
    companyName: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    bus?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    countryRegionCode?: string | undefined;
    vatNumber?: string | undefined;
    currentServiceSaldo?: number | undefined;
    emails?: string[] | undefined;
    productLines: ProductLine[];
    paymentLink: string;
    totalAmountExclVat: number;
    totalAmountInclVat: number;
    totalVat: number;
    vatByRate: { [key: string]: number; };
    callbackUrl: string;
    sessionLocked?: boolean;
}

export class ProductLine implements IProductLine {
    description!: string;
    price!: number;
    vatPercentage!: number;
    productLineId!: string;

    constructor(data?: IProductLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.price = _data["price"];
            this.vatPercentage = _data["vatPercentage"];
            this.productLineId = _data["productLineId"];
        }
    }

    static fromJS(data: any): ProductLine {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["price"] = this.price;
        data["vatPercentage"] = this.vatPercentage;
        data["productLineId"] = this.productLineId;
        return data;
    }
}

export interface IProductLine {
    description: string;
    price: number;
    vatPercentage: number;
    productLineId: string;
}

export class CreatePaymentSession implements ICreatePaymentSession {
    callBackUrl?: string;
    athumiService?: AthumiService;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    voOrgCode?: string | undefined;
    subjectId?: string | undefined;
    transactionId?: string;
    products?: ProductLineDto[];

    constructor(data?: ICreatePaymentSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callBackUrl = _data["callBackUrl"];
            this.athumiService = _data["athumiService"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.voOrgCode = _data["voOrgCode"];
            this.subjectId = _data["subjectId"];
            this.transactionId = _data["transactionId"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductLineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePaymentSession {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callBackUrl"] = this.callBackUrl;
        data["athumiService"] = this.athumiService;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["voOrgCode"] = this.voOrgCode;
        data["subjectId"] = this.subjectId;
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePaymentSession {
    callBackUrl?: string;
    athumiService?: AthumiService;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    voOrgCode?: string | undefined;
    subjectId?: string | undefined;
    transactionId?: string;
    products?: ProductLineDto[];
}

export class SubmitPaymentSession implements ISubmitPaymentSession {
    paymentMethod!: PaymentMethod;
    street!: string;
    streetNumber!: string;
    bus?: string | undefined;
    postCode!: string;
    city!: string;
    countryRegionCode!: string;
    vatNumber?: string | undefined;
    ownReference?: string | undefined;
    emails!: string[];

    constructor(data?: ISubmitPaymentSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.emails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethod = _data["paymentMethod"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryRegionCode = _data["countryRegionCode"];
            this.vatNumber = _data["vatNumber"];
            this.ownReference = _data["ownReference"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): SubmitPaymentSession {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitPaymentSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryRegionCode"] = this.countryRegionCode;
        data["vatNumber"] = this.vatNumber;
        data["ownReference"] = this.ownReference;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface ISubmitPaymentSession {
    paymentMethod: PaymentMethod;
    street: string;
    streetNumber: string;
    bus?: string | undefined;
    postCode: string;
    city: string;
    countryRegionCode: string;
    vatNumber?: string | undefined;
    ownReference?: string | undefined;
    emails: string[];
}

export class ProcessingSession implements IProcessingSession {
    sessionId?: string;
    athumiService?: AthumiService;
    sessionState?: SessionState;
    sessionType?: SessionType;
    callbackUrl?: string | undefined;
    orginatingPaymentSessionId?: string | undefined;

    constructor(data?: IProcessingSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.athumiService = _data["athumiService"];
            this.sessionState = _data["sessionState"];
            this.sessionType = _data["sessionType"];
            this.callbackUrl = _data["callbackUrl"];
            this.orginatingPaymentSessionId = _data["orginatingPaymentSessionId"];
        }
    }

    static fromJS(data: any): ProcessingSession {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["athumiService"] = this.athumiService;
        data["sessionState"] = this.sessionState;
        data["sessionType"] = this.sessionType;
        data["callbackUrl"] = this.callbackUrl;
        data["orginatingPaymentSessionId"] = this.orginatingPaymentSessionId;
        return data;
    }
}

export interface IProcessingSession {
    sessionId?: string;
    athumiService?: AthumiService;
    sessionState?: SessionState;
    sessionType?: SessionType;
    callbackUrl?: string | undefined;
    orginatingPaymentSessionId?: string | undefined;
}

export class ProductPrice implements IProductPrice {
    productCode!: string;
    price?: number;
    variant?: string;
    validFrom?: string | undefined;
    validUntil?: string | undefined;

    constructor(data?: IProductPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.price = _data["price"];
            this.variant = _data["variant"];
            this.validFrom = _data["validFrom"];
            this.validUntil = _data["validUntil"];
        }
    }

    static fromJS(data: any): ProductPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["price"] = this.price;
        data["variant"] = this.variant;
        data["validFrom"] = this.validFrom;
        data["validUntil"] = this.validUntil;
        return data;
    }
}

export interface IProductPrice {
    productCode: string;
    price?: number;
    variant?: string;
    validFrom?: string | undefined;
    validUntil?: string | undefined;
}

export class TopUpSession implements ITopUpSession {
    sessionId?: string;
    service?: AthumiService;
    sessionState?: SessionState;
    amount?: number | undefined;
    submitTimeUtc?: string | undefined;
    vatNumber?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    countryRegionCode?: string;
    emails?: string[];
    paymentLink?: string;
    callbackUrl?: string;
    transactionId?: string;
    originatingPaymentSessionId?: string | undefined;

    constructor(data?: ITopUpSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.service = _data["service"];
            this.sessionState = _data["sessionState"];
            this.amount = _data["amount"];
            this.submitTimeUtc = _data["submitTimeUtc"];
            this.vatNumber = _data["vatNumber"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryRegionCode = _data["countryRegionCode"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.paymentLink = _data["paymentLink"];
            this.callbackUrl = _data["callbackUrl"];
            this.transactionId = _data["transactionId"];
            this.originatingPaymentSessionId = _data["originatingPaymentSessionId"];
        }
    }

    static fromJS(data: any): TopUpSession {
        data = typeof data === 'object' ? data : {};
        let result = new TopUpSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["service"] = this.service;
        data["sessionState"] = this.sessionState;
        data["amount"] = this.amount;
        data["submitTimeUtc"] = this.submitTimeUtc;
        data["vatNumber"] = this.vatNumber;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryRegionCode"] = this.countryRegionCode;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["paymentLink"] = this.paymentLink;
        data["callbackUrl"] = this.callbackUrl;
        data["transactionId"] = this.transactionId;
        data["originatingPaymentSessionId"] = this.originatingPaymentSessionId;
        return data;
    }
}

export interface ITopUpSession {
    sessionId?: string;
    service?: AthumiService;
    sessionState?: SessionState;
    amount?: number | undefined;
    submitTimeUtc?: string | undefined;
    vatNumber?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    countryRegionCode?: string;
    emails?: string[];
    paymentLink?: string;
    callbackUrl?: string;
    transactionId?: string;
    originatingPaymentSessionId?: string | undefined;
}

export class InstantSubmitTopUpSession implements IInstantSubmitTopUpSession {
    street?: string;
    streetNumber?: string;
    bus?: string | undefined;
    postCode?: string;
    city?: string;
    countryRegionCode?: string;
    vatNumber?: string | undefined;
    amount?: number;
    ownReference?: string | undefined;
    emails?: string[];
    service?: AthumiService;
    transactionId?: string;
    name?: string | undefined;
    originatingSessionId?: string | undefined;
    callBackUrl?: string | undefined;
    voOrgCode?: string | undefined;
    subjectId?: string | undefined;

    constructor(data?: IInstantSubmitTopUpSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryRegionCode = _data["countryRegionCode"];
            this.vatNumber = _data["vatNumber"];
            this.amount = _data["amount"];
            this.ownReference = _data["ownReference"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.service = _data["service"];
            this.transactionId = _data["transactionId"];
            this.name = _data["name"];
            this.originatingSessionId = _data["originatingSessionId"];
            this.callBackUrl = _data["callBackUrl"];
            this.voOrgCode = _data["voOrgCode"];
            this.subjectId = _data["subjectId"];
        }
    }

    static fromJS(data: any): InstantSubmitTopUpSession {
        data = typeof data === 'object' ? data : {};
        let result = new InstantSubmitTopUpSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryRegionCode"] = this.countryRegionCode;
        data["vatNumber"] = this.vatNumber;
        data["amount"] = this.amount;
        data["ownReference"] = this.ownReference;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["service"] = this.service;
        data["transactionId"] = this.transactionId;
        data["name"] = this.name;
        data["originatingSessionId"] = this.originatingSessionId;
        data["callBackUrl"] = this.callBackUrl;
        data["voOrgCode"] = this.voOrgCode;
        data["subjectId"] = this.subjectId;
        return data;
    }
}

export interface IInstantSubmitTopUpSession {
    street?: string;
    streetNumber?: string;
    bus?: string | undefined;
    postCode?: string;
    city?: string;
    countryRegionCode?: string;
    vatNumber?: string | undefined;
    amount?: number;
    ownReference?: string | undefined;
    emails?: string[];
    service?: AthumiService;
    transactionId?: string;
    name?: string | undefined;
    originatingSessionId?: string | undefined;
    callBackUrl?: string | undefined;
    voOrgCode?: string | undefined;
    subjectId?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}